import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { useFormatPrice } from '../hooks/useFormatPrice';
export const P3Extension = createModuleExtension(_ref => {
  let {
    productTypeId,
    purchaseContext
  } = _ref;
  return {
    extensionName: 'p3Extension',
    Provider: _ref2 => {
      let {
        children
      } = _ref2;
      return /*#__PURE__*/React.createElement(PremiumPurchasePlatformModule.Provider, {
        translations: {
          Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
        },
        context: {
          productTypeId,
          purchaseContext
        }
      }, children);
    },
    SDK: {
      useFormatPrice
    }
  };
});
//# sourceMappingURL=p3.extension.js.map